module.exports = __webpack_public_path__ + "static/media/img1.889af28e.webp";